import { createContext, useContext } from 'react';
import { IUseGetContextResData } from '../types';

interface ISessionContext extends Partial<IUseGetContextResData> {
    setContext: (context: IUseGetContextResData) => void;
    fetchContext: (skipLoading?: boolean) => void;
    testUserAgent: string | null;
}

const SessionContext = createContext<ISessionContext | null>(null);

export const SessionProvider = SessionContext.Provider;

export const useSession = function () {
    return useContext(SessionContext);
};
